import axiosInstance from "./axiosInstance";
import { Category } from "../types/Category";
import { InventorySummary } from "../types/Inventory";
import { SearchFilter } from "../types/SearchFilter";

function authHeader(token?: string) {
  if (!token || token.trim().length === 0) return {};
  return { Authorization: `Bearer ${token}` };
}

export async function fetchStoreCategories(token: string): Promise<Category[]> {
  const response = await axiosInstance.get<Category[]>("/stores/categories", {
    headers: authHeader(token),
  });
  return response.data ?? [];
}

export async function searchStoreInventories(
  token: string,
  payload: SearchFilter
): Promise<InventorySummary[]> {
  const response = await axiosInstance.post<InventorySummary[]>(
    "/stores/inventories/search",
    payload,
    { headers: authHeader(token) }
  );
  return response.data ?? [];
}
